<div class="carousel-container" *ngIf="(pendingTransactions$ | async)?.length">
    <div class="content">
        <div class="header">
            <div class="text">
                <span class="title">Pending transactions</span>
                <span class="chips">{{filteredTransactions?.length}}</span>
            </div>
            <div class="carousel-controls">
                <div class="search-container">
                    <app-search-input class="search" [class.shrunk]="isSearchShrunk"
                        [formControl]="pendingTransactionsSearchControl"
                        [color]="SearchInputColorEnum.Green"
                        [hideDropdown]="true"
                        [placeholder]="'Search by Rx#, NDC, Pt. Name'"
                        (click)="isSearchShrunk = false"
                        (searchBlurred)="searchInputBlurred()"
                        (searchCleared)="searchCleared()"
                        [isShrunkOnlyIconVisible]="isSearchShrunk"
                    ></app-search-input>
                </div>
                <app-button customClasses="px-4"
                    text="Bulk Confirm"
                    [minWidth]="120"
                    (clicked)="navigateToBulkVerify()"
                    [disabled]="bulkVerifyInProgress$ | async"
                ></app-button>
            </div>
        </div>
        <div class="cards-container" #cardsContainer [class.carousel-end]="reachedEnd()">
            <div class="chevron left" *ngIf="!shouldHideBackForward()">
                <button class="pagination-button" (click)="back()" [disabled]="reachedStart()"
                (clickAndHold)="onBackClickedAndHeld()" [intervalSpeed]="250" appClickAndHold> ❮ </button>
            </div>

            <div class="card" *ngFor="let item of mediator; let i = index;"
                [class.carousel-first-card]="i === 0"
                [class.carousel-controls-hidden]="shouldHideBackForward()"
                [class.carousel-reached-end]="i === mediator?.length - 1 && reachedEnd()"
                [class.carousel-start]="isFirstElement(item?.id)"
                [class.not-enough-inventory]="item?.inventoryOnHand - item?.addedQuantity < 0 && item?.activityType !== 3"
                (click)="openConfirmationDialog(item.id)">
                <div class="rx-number">
                <div>
                    Rx{{item?.rxNumber}} <span *ngIf="item?.isPartialFill && item?.partialNumber > 0"> - {{item.partialNumber}}</span>
                </div>
                <app-badge *ngIf="item?.activityType === 3"
                    [color]="BadgeColorsEnum.Blue"> Amended </app-badge>
                <app-badge *ngIf="item?.activityType === 0 && item?.description && !item?.isC2KeepPartialDispense"
                    [maxWidth]="'200px'"
                > {{item?.description}} </app-badge>
                <app-badge *ngIf="item?.isC2KeepPartialDispense && item?.description"
                    [color]="BadgeColorsEnum.Yellow"> {{item?.description}} 
                </app-badge>
            </div>
            <div class="friendly-name">{{item?.friendlyName}}</div>
            <div class="patient-name">{{item?.patientName}}</div>
            </div>

            <div class="chevron right" *ngIf="!shouldHideBackForward()">
                <button class="pagination-button" (click)="forward()" [disabled]="reachedEnd()"
                (clickAndHold)="onForwardClickedAndHeld()" [intervalSpeed]="250" appClickAndHold> ❯ </button>
            </div>
        </div>
        <div *ngIf="!filteredTransactions?.length" class="search-no-result">
            No pending transaction card found
        </div>
    </div>
</div>
<app-pending-transaction-dialog *ngIf="showConfirmationDialog"
[show]="true" id="pending-transaction-dialog"
(cancel)="showConfirmationDialog = false" (dialogConfirmationEmitted)="openConfirmationDialog($event)" (openSelf)="showConfirmationDialog = true"
></app-pending-transaction-dialog>

<app-dialog *ngIf="showNoValidTransactionError"
  [showHeader]="true"
  [header]="'Transaction No Longer Valid'"
  [subHeader]="'This transaction no longer needs to be confirmed in C2Keep.'"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="showNoValidTransactionError">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'Ok'" class="save-btn" (click)="showNoValidTransactionError=false" [minWidth]="50">
        </app-button>
    </div>
</app-dialog>

<app-dialog *ngIf="unnecessaryToConfirmOwedPendingTransactionDialogState$ | async; let state"
  [showHeader]="true"
  [header]="'Transaction No Longer Needs Confirmation'"
  [subHeader]="'Rx - ' + state?.rxNumber + ' was manually returned to stock by ' + state?.user + ' on ' + (state?.when | formattedDate: 'MM d a, HH:mm') + '. This owed qty is no longer valid.'"
  [maxWidth]="490"
  [headerIcon]="'warning'"
  [show]="true">
    <div class="flex flex-row-reverse">
        <app-button customClasses="px-4" [text]="'Ok'" class="save-btn" (click)="closeNoNeedToConfirmCardDialog()" [minWidth]="50">
        </app-button>
    </div>
</app-dialog>